/* The Ritual of Giving — Soft Atelier interactions: live cart personalisation plus user-controlled, reduced-motion-safe assembly playback. */
(() => {
  const root = document.querySelector('[data-tbe-root]');
  if (!root) return;
  const motion = root.querySelector('[data-tbe-motion]');
  const motionToggle = root.querySelector('[data-tbe-motion-toggle]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const updateMotionControl = () => {
    if (!motion || !motionToggle) return;
    const isPlaying = !motion.paused && !motion.ended;
    motionToggle.setAttribute('aria-pressed', String(isPlaying));
    motionToggle.setAttribute('aria-label', `${isPlaying ? 'Pause' : 'Play'} gift-box assembly motion`);
    motionToggle.innerHTML = `<span aria-hidden="true">${isPlaying ? 'Ⅱ' : '▶'}</span> ${isPlaying ? 'Pause motion' : 'Play motion'}`;
  };
  const respectMotionPreference = () => {
    if (!motion) return;
    if (reducedMotion.matches) { motion.pause(); updateMotionControl(); }
    else { motion.play().catch(() => updateMotionControl()); }
  };
  if (motion && motionToggle) {
    motion.addEventListener('play', updateMotionControl);
    motion.addEventListener('pause', updateMotionControl);
    motionToggle.addEventListener('click', () => { if (motion.paused) motion.play().catch(() => {}); else motion.pause(); });
    reducedMotion.addEventListener?.('change', respectMotionPreference);
    respectMotionPreference();
  }
  const fmt = new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR', maximumFractionDigits: 0 });
  const prices = {
    starter: Number(root.dataset.tbeStarterPrice) || 0,
    signature: Number(root.dataset.tbeSignaturePrice) || 0,
    luxury: Number(root.dataset.tbeLuxuryPrice) || 0
  };
  const data = {
    step: 0,
    experience: { value: 'starter', label: 'Starter Experience', variant: '43819218042915', price: prices.starter, eyebrow: 'For trying something new' },
    mood: 'Golden hour', fragrance: 'Rose Affair', recipient: 'Someone special', recipientName: '', occasion: 'Just because', isGift: true, message: '', extras: []
  };
  const builder = root.querySelector('#tbe-builder');
  const panels = [...root.querySelectorAll('[data-tbe-panel]')];
  const progress = [...root.querySelectorAll('[data-tbe-step]')];
  const setStep = (next) => {
    data.step = Math.max(0, Math.min(7, next));
    panels.forEach(panel => { panel.hidden = Number(panel.dataset.tbePanel) !== data.step; });
    progress.forEach(btn => btn.classList.toggle('is-active', Number(btn.dataset.tbeStep) === data.step));
    root.querySelector('[data-tbe-step-number]').textContent = `Step ${String(data.step + 1).padStart(2, '0')} / 08`;
    root.querySelector('[data-tbe-back]').disabled = data.step === 0;
    root.querySelector('[data-tbe-next]').hidden = data.step === 7;
    root.querySelector('[data-tbe-add]').hidden = data.step !== 7;
    if (data.step === 7) renderReview();
  };
  const open = (chosen) => {
    if (chosen) root.querySelector(`[data-tbe-select="experience"][data-tbe-value="${chosen}"]`)?.click();
    builder.hidden = false; setStep(0); builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  root.querySelectorAll('[data-tbe-open]').forEach(btn => btn.addEventListener('click', () => open(btn.dataset.tbeExperience)));
  root.querySelector('[data-tbe-close]').addEventListener('click', () => { builder.hidden = true; });
  progress.forEach(btn => btn.addEventListener('click', () => setStep(Number(btn.dataset.tbeStep))));
  root.querySelector('[data-tbe-next]').addEventListener('click', () => setStep(data.step + 1));
  root.querySelector('[data-tbe-back]').addEventListener('click', () => setStep(data.step - 1));
  root.querySelectorAll('[data-tbe-select]').forEach(btn => btn.addEventListener('click', () => {
    const key = btn.dataset.tbeSelect;
    root.querySelectorAll(`[data-tbe-select="${key}"]`).forEach(item => item.classList.remove('is-selected'));
    btn.classList.add('is-selected');
    if (key === 'experience') {
      const eyebrows = { starter: 'For trying something new', signature: 'Our complete signature experience', luxury: 'For when ordinary isn’t enough' };
      data.experience = { value: btn.dataset.tbeValue, label: btn.dataset.tbeLabel, variant: btn.dataset.tbeVariant, price: prices[btn.dataset.tbeValue], eyebrow: eyebrows[btn.dataset.tbeValue] };
    } else data[key] = btn.dataset.tbeValue;
    updateSummary();
  }));
  root.querySelectorAll('[data-tbe-input]').forEach(input => input.addEventListener('input', () => {
    data[input.dataset.tbeInput] = input.type === 'checkbox' ? input.checked : input.value;
    if (input.dataset.tbeInput === 'message') root.querySelector('[data-tbe-message-count]').textContent = input.value.length;
  }));
  const updateSummary = () => {
    root.querySelector('[data-tbe-summary-eyebrow]').textContent = data.experience.eyebrow;
    root.querySelector('[data-tbe-summary-title]').textContent = data.experience.label;
    root.querySelector('[data-tbe-summary-experience]').textContent = data.experience.label;
    root.querySelector('[data-tbe-summary-mood]').textContent = data.mood;
    root.querySelector('[data-tbe-summary-fragrance]').textContent = data.fragrance;
    root.querySelector('[data-tbe-summary-extras]').textContent = data.extras.length ? `${data.extras.length} selected` : 'None yet';
    root.querySelector('[data-tbe-summary-total]').textContent = fmt.format(data.experience.price + data.extras.reduce((sum, extra) => sum + extra.price, 0));
  };
  const renderReview = () => {
    const recipient = data.recipientName || data.recipient;
    const rows = [['Experience', data.experience.label], ['Mood', data.mood], ['Fragrance', data.fragrance], ['Recipient', recipient], ['Occasion', data.occasion], ['Is this a gift?', data.isGift ? 'Yes' : 'No'], ['Personal message', data.message || 'Not added'], ['Extras', data.extras.length ? data.extras.map(extra => extra.label).join(', ') : 'None selected']];
    root.querySelector('[data-tbe-review]').innerHTML = rows.map(([term, value]) => `<div><dt>${term}</dt><dd>${value}</dd></div>`).join('');
    updateSummary();
  };
  const status = root.querySelector('[data-tbe-status]');
  const cart = root.querySelector('[data-tbe-cart]');
  const cartLines = root.querySelector('[data-tbe-cart-lines]');
  const openCart = () => { cart.hidden = false; refreshCart(); };
  root.querySelector('[data-tbe-cart-open]').addEventListener('click', openCart);
  root.querySelector('[data-tbe-cart-close]').addEventListener('click', () => { cart.hidden = true; });
  const refreshCart = async () => {
    try {
      const response = await fetch('/cart.js'); const cartData = await response.json();
      root.querySelector('[data-tbe-cart-count]').textContent = cartData.item_count;
      if (!cartData.items.length) { cartLines.innerHTML = '<p>Your bag is ready for a beautiful beginning.</p>'; return; }
      cartLines.innerHTML = cartData.items.map(item => `<div class="tbe-cart-line"><div><b>${item.product_title}</b><small>${Object.entries(item.properties || {}).filter(([, value]) => value).map(([key, value]) => `${key}: ${value}`).join(' · ')}</small></div><strong>${fmt.format(item.final_line_price / 100)}</strong></div>`).join('');
    } catch { cartLines.innerHTML = '<p>Your bag could not be refreshed. Please try again.</p>'; }
  };
  root.querySelector('[data-tbe-add]').addEventListener('click', async () => {
    status.textContent = 'Adding your selection to the bag…';
    const properties = { 'Experience': data.experience.label, 'Mood': data.mood, 'Fragrance': data.fragrance, 'Recipient': data.recipientName || data.recipient, 'Occasion': data.occasion, 'Personal message': data.message, 'Is this a gift?': data.isGift ? 'Yes' : 'No', 'Recipient name': data.recipientName };
    const items = [{ id: Number(data.experience.variant), quantity: 1, properties }];
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) throw new Error('This experience is currently unavailable. Please choose another experience or contact us for assistance.');
      status.textContent = 'Added to your bag. Review your order when you are ready.'; openCart();
    } catch (error) {
      status.textContent = error.message || 'Your selection could not be added to the bag. Please try again.';
    }
  });
  updateSummary(); setStep(0);
})();
